import { useDispatch, useSelector } from '../../../../store/store';
import { setNotification } from '../../../../store/general/slice';
import MotionWrapper from '../../../../containers/MotionWrapper';
import { useCountDown } from '../../../../hooks/useCountDown';
import { toTime } from '../../../../utils/generalHelpers';
import Button from '../../../../components/Button';
import OTP from '../../../../components/OTP';
import { useEffect, useState } from 'react';
import styles from './style.module.scss';
import {
    confirmSignUpThunk,
    resendEmailConfirmationCodeThunk,
} from '../../../../store/signUp/thunks';
import {
    selectUserEmail,
    selectFetchStatus,
} from '../../../../store/signUp/selectors';

export default function VerifyEmail() {
    const dispatch = useDispatch();
    const [otp, setOtp] = useState('');
    const email = useSelector(selectUserEmail);
    const { counter, restart } = useCountDown(180, 'start');
    const { minutes, seconds } = toTime(counter);
    const fetchStatus = useSelector(selectFetchStatus);

    useEffect(() => {
        if (otp.length === 6) next();
    }, [otp]);

    const next = () => {
        dispatch(confirmSignUpThunk({ username: email, confirmationCode: otp }));
    };

    const resendOTPCode = () => {
        if (counter > 0) return;
        dispatch(resendEmailConfirmationCodeThunk(email))
            .then(() => {
                restart();
            })
            .catch(() => {
                dispatch(setNotification(['An error occured, please try again.', 'error']));
            })
    };

    return (
        <MotionWrapper className={styles.wrapper}>
            <span className={styles.description}>
                Verify your Account, enter the Sent Code to:
            </span>
            <span className={styles.sentTo}>
                {email}
            </span>
            <OTP
                value={otp}
                onChange={setOtp}
                numInputs={6}
                onChangeRegex={/^([0-9]{0,})$/}
            />
            <div className={styles.counter}>
                <span className={styles.counter_time}>
                    {minutes}:{seconds} Remaining
                </span>
                <span
                    onClick={resendOTPCode}
                    data-is-deactive={counter > 0}
                    className={styles.counter_resend}
                >
                    Resend code
                </span>
            </div>
            <Button
                text="Confirm"
                onClick={next}
                className={styles.next}
                disabled={otp.length !== 6}
                loading={fetchStatus === 'Pending'}
            />
        </MotionWrapper>
    );
};
